import React from 'react';

interface IProps {
    id: string;
    value: boolean;
    onChange: (checked: boolean) => void;
}

const TermsAndConditions: React.FC<IProps> = ({ id, value, onChange }) => {
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    return (
        <div>
            <label htmlFor={id}>
                I agree to the{' '}
                <a href='https://localhost:4000/b2b/termsandconditions' target='_blank' rel='noopener noreferrer'>
                    Terms and Conditions
                </a>{' '}
                &{' '}
                <a href='https://localhost:4000/b2b/privacy' target='_blank' rel='noopener noreferrer'>
                    Privacy Policy. *
                </a>
            </label>
            <input id={id} type='checkbox' checked={value} onChange={handleCheckboxChange} />
        </div>
    );
};

export default TermsAndConditions;
